/* SUPER10 — eBay-style estimated delivery dates (business-day math, client-side). */
(function () {
  function addBusinessDays(start, n) {
    var d = new Date(start.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }
  function init() {
    var boxes = document.querySelectorAll('.s10-delivery');
    boxes.forEach(function (box) {
      if (box.dataset.s10Done) return;
      var handling = parseInt(box.getAttribute('data-handling') || '0', 10);
      var today = new Date();
      box.querySelectorAll('.s10-delivery__row').forEach(function (row) {
        var min = parseInt(row.getAttribute('data-min') || '0', 10);
        var max = parseInt(row.getAttribute('data-max') || '0', 10);
        var e1 = addBusinessDays(today, handling + min);
        var e2 = addBusinessDays(today, handling + max);
        var est = row.querySelector('.s10-delivery__est');
        if (est) {
          est.innerHTML = 'Estimated between <strong>' + fmt(e1) + '</strong> and <strong>' + fmt(e2) + '</strong>';
        }
      });
      box.dataset.s10Done = '1';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
